export const baseHelpPageUrl = 'https://www.pearsonschoolsandfecolleges.co.uk/help/helphub';